import { useState, useContext, createContext } from "react";
import { BASE_ADMIN_PATH } from "Constants/Views";

import { useHistory } from "react-router";

const AdminContext = createContext();
const ADMIN_INIT_STATE = {
  name: "",
  id: "",
};
const AdminProvider = ({ children }) => {
  let history = useHistory();
  const [activeView, setActiveView] = useState(BASE_ADMIN_PATH);
  const [admin, setAdmin] = useState(ADMIN_INIT_STATE);

  const setActiveAdminView = (view) => {
    setActiveView(view);
    history.push(view);
  };

  const setAdminDetails = (adminDetails) => {
    localStorage.setItem("ADMIN_DATA", JSON.stringify(adminDetails));
    setAdmin(adminDetails);
  };
  const getAdminDetails = () => {
    const AdminDetails = JSON.parse(localStorage.getItem("ADMIN_DATA"));
    if (admin.name) {
      return admin;
    }
    if (AdminDetails) {
      return AdminDetails;
    }
    return;
  };
  const resetAdminDetails = () => {
    setAdmin("");
    localStorage.setItem("ADMIN_DATA", JSON.stringify(""));
  };
  return (
    <AdminContext.Provider
      value={{
        activeView,
        setActiveAdminView,
        setAdminDetails,
        getAdminDetails,
        resetAdminDetails,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminContext = () => {
  return useContext(AdminContext);
};

export { AdminContext, AdminProvider };
